export default __webpack_public_path__ + "static/media/me1.3801fc0a.jpg";